/**
 * Public-facing URL of the deployed app. When set, this is used for share
 * links, email invites and OAuth callbacks so they always point at the
 * canonical production domain regardless of which host the user currently
 * has open (preview domain, localhost, etc).
 *
 * Configured via `VITE_PUBLIC_APP_URL` (no trailing slash). Falls back to
 * `window.location.origin` when unset so dev/preview builds still work.
 */
export function getAppUrl(): string {
  const configured = import.meta.env.VITE_PUBLIC_APP_URL as string | undefined;
  if (configured && configured.length > 0) return configured.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) return window.location.origin;
  return '';
}
